






































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
import attachmentCaptionForDisplay from 'surface/attachment_caption_for_display'

@Component({ components: { MultilineInput } })
export default class BeethovenAttachmentCaption extends Mixins(IntlMixin) {
  @Prop() caption!: string
  @Prop() attachmentTitle!: string
  @Prop({ default: true }) canEdit!: boolean
  /**
   * How the component should decide to show dark mode: Using browser or with custom isDark prop
   */
  @Prop({ default: 'browser' }) darkThemeType!: 'browser' | 'custom'
  @Prop({ default: 'browser' }) isDark!: false

  editing = false

  get captionBeingDisplayed(): string {
    if (this.editing) {
      return attachmentCaptionForDisplay({
        postAttachmentCaption: this.caption,
        defaultCaption: '',
      })
    }
    return attachmentCaptionForDisplay({
      postAttachmentCaption: this.caption,
      defaultCaption: this.attachmentTitle,
    })
  }

  get xCaption(): boolean {
    return this.canEdit || this.captionBeingDisplayed !== ''
  }

  onChange(newValue: string) {
    this.$emit('change', newValue)
  }

  onEditStart() {
    if (!this.canEdit) return
    this.editing = true
  }

  onEditEnd() {
    this.editing = false
  }
}
